// Fichier de constantes pour les projets d'art et de photographie

// Constante pour ArtGallery.jsx
export const WELCOME_ART = "Bienvenue dans ma ";
export const ART_GALLERY = "Galerie d'Art";
export const ART_PROJECT = "Projets d'Art";
export const ART_INSTA = "Instagram";

// Constante pour PhotoGallery.jsx
export const WELCOME_PHOTO = "Bienvenue dans ma ";
export const PHOTO_GALLERY = "Galerie de Photo";
export const PHOTO_PROJECT = "Projets de Photo";
export const PHOTO_INSTA = "Instagram";
